import FutureMedicalCard from "components/Card/FutureMedicalCard";
import ICDCodingBlock from "components/ICDCoding/ICDCodingBlock";
import type { ICDUpdateData } from "components/ICDCoding/icdAdapter";
import { lienToIcdObject } from "components/ICDCoding/icdAdapter";
import { ControlledTextArea } from "components/inputs";
import ControlledSelect from "components/inputs/Select/ControlledSelect";
import type { Control } from "react-hook-form";
import { usePatchLienByIdMutation } from "services/lien-api";
import type { ConstantTypes } from "types/DataTypes";

import type { Lien, LienFormValues } from "../LienTypes";

type LienSubrogationSectionProps = {
  lien: Lien;
  control: Control<LienFormValues>;
  handleFieldChange: (field: string | null, value: unknown) => Promise<void>;
  constants?: ConstantTypes;
};

const LienSubrogationSection = ({
  lien,
  control,
  handleFieldChange,
  constants,
}: LienSubrogationSectionProps) => {
  const icdData = lienToIcdObject(lien);
  const [patchLien] = usePatchLienByIdMutation();

  const handleIcdSave = async (data: ICDUpdateData) => {
    await patchLien({
      lienId: lien.id.toString(),
      data,
    }).unwrap();
  };

  return (
    <div className="swim-column lien-subrogation-column">
      <FutureMedicalCard heading="Subrogation Information">
        <ControlledSelect
          control={control}
          name="jurisdiction"
          label="Jurisdiction"
          errors={{}}
          options={constants?.JURISDICTIONS}
          onSave={(option) => handleFieldChange("jurisdiction", option?.value)}
          widthVariant="full"
        />

        <ControlledTextArea
          control={control}
          name="accident_description"
          label="Accident Description"
          advancedEdit={true}
          maxLength={2000}
          errors={{}}
          onSave={(value) => handleFieldChange("accident_description", value)}
        />
      </FutureMedicalCard>

      <ICDCodingBlock data={icdData} onSave={handleIcdSave} />
    </div>
  );
};

export default LienSubrogationSection;
